export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 3_16.37a485ff.jpg";